var map = {
	"./close.svg": "1389",
	"./country.svg": "0dd0",
	"./facebook-logo-blue.svg": "f773",
	"./facebook-logo-white.svg": "5ab4",
	"./go-next-arrow.svg": "a0c6",
	"./label-premium.svg": "a8fc",
	"./st-audio.svg": "8ff8",
	"./st-avatar-white.svg": "3a12",
	"./st-avatar.svg": "c2ca",
	"./st-button-facebook-white.svg": "00c3",
	"./st-button-facebook.svg": "d227",
	"./st-button-twitter-white.svg": "1320",
	"./st-button-twitter.svg": "c40e",
	"./st-logo-white.svg": "762e",
	"./st-logo.svg": "74d6",
	"./st-no-audio.svg": "6938",
	"./straits-times-logo-white.svg": "3b4b",
	"./straits-times-logo.svg": "4d9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd26";